import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { SIGN_IN_PATH } from 'routes/constants.routes'
import { ErrorBoundary } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'
import { ApplicationStoreProvider } from 'context/ApplicationStore'

const ApplicationPrivateRoute = ({ component: Component, componentProps = {}, ...rest }) => {
  const { authStore } = useAuthStore()

  return (
    <Route
      {...rest}
      render={props =>
        authStore.isLoggedIn ? (
          <ErrorBoundary>
            <ApplicationStoreProvider>
              <Component {...props} {...componentProps} />
            </ApplicationStoreProvider>
          </ErrorBoundary>
        ) : (
          <Redirect to={SIGN_IN_PATH} />
        )
      }
    />
  )
}

export default ApplicationPrivateRoute
